import { usePage } from "@inertiajs/react";

const VideoLayout = ({
  layout,
}) => {
  const { is_mobile } = usePage().props;

  const iframeURL = (layout) => {
    const match = layout.video_url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (match && match[1]) {
      const queryParams = `autoplay=0&autopause=0&controls=${layout.play_mode === "loop" ? "0" : "1"}&loop=${layout.play_mode === "loop" ? "1" : "0"}&muted=${layout.play_mode === "loop" ? "1" : "0"}&preload=${is_mobile ? "none" : "auto"}&min_quality=720p`;
      return `https://player.vimeo.com/video/${match[1]}?${queryParams}`;
    }
    return null;
  }

  return (
    <div style={{ padding: "56.25% 0 0 0", position: "relative" }} id={`vimeo-${layout.id}`}>
      <iframe
        src={iframeURL(layout)}
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
      ></iframe>
    </div>
  );
};

export default VideoLayout;
